import React from 'react'

const Goals = () => {
  return (
    <div className="npay-goals">
      <h4>Goals</h4>
      <p>
        <b>Provide seamless user experience</b> <br />
        Ensuring good user exprience by simplifying the app and its payments system.
      </p>
      <p>
        <b>Drive confidence </b> <br />
        Solve the problem of lack of confidence in Nigeria’s payment platforms and driving popularity of the app.
      </p>
      <p>
        <b>Encourage tax payers to the app</b> <br />
        The primary targets of the app, which are taxpayers should be driven to download and use the app as first choice platform for settling bills.
      </p>
    </div>
  )
}

export default Goals